<template>
	<popup title="Are you sure?" small @close="$emit('close')">
		<template v-slot:content>
			<p>Are you sure you want to delete this automation?</p>
		</template>
		<template v-slot:actions>
			<v-button label="Delete automation" slim @click="deleteAutomation()" border red :loading="loading"/>
			<v-button @click="$emit('close')" slim label="Keep automation" />
		</template>
	</popup>
</template>

<script>
import API from "@/api"

import VButton from "@/components/base/v-button";
import Popup from "@/components/base/popup";
export default {
    name: "DeleteAutomationPopup",
  components: {Popup, VButton},
  props:['automation', 'isPlus'],
    mixins: [API],
    data() {
        return {
          loading: false,
        }
    },
    methods: {
      async deleteAutomation() {
        this.loading = true;
        try {
        	if (this.isPlus)
		        await this.api.wsteps.deleteAutomation(this.automation.id);
	        else
	          await this.api.steps.deleteAutomation(this.automation.id);
          this.$emit('done', this.automation);
        } catch (e) {
          this.$notify({
            group: 'main',
            title: "Something went wrong! try again.",
            type: 'error',
          });
          console.error(e)
        } finally {
          this.loading = false;
        }
      },
    },
}
</script>

<style>
    .brdr_box_w_checkbox h3 b {
        margin-right: 3px;
    }
</style>
